@use '@design/design-tokens/typography/typography' as *;

.proportionChangeContainer {
  gap: 16px;
  display: flex;
  flex-direction: row;
}

.dateSpan {
  text-align: end;
  color: var(--text-soft);
}
